module.exports.SEARCH_MAX_RESULTS = 10;

module.exports.WATERSHED_LAYER = 'inecc:canvcc';
module.exports.LAYER_USODESUELO = 'canvccrausv';
module.exports.LAYER_POBLACION = 'inecc_canvcc_ra_cont_nac_pob';
module.exports.LAYER_AGRARIO = 'inecc_canvcc_ra_nucleos_agrarios';
module.exports.LAYER_CARRETERAS = 'inecc_canvcc_ra_carreteras';
module.exports.LAYER_INCENDIOS = 'incendios20152018';
module.exports.DEFAULT_REGION_VARIABLE = module.exports.LAYER_USODESUELO;
module.exports.DEFAULT_MAP_ANIMATION_DURATION = 300;

module.exports.DEFAULT_CLIMATE_VARIABLE = 'prec';

module.exports.WATERSHED_LAYER_SEARCH_FIELDS = ['nombrec', 'nombrerha'];
module.exports.WATERSHED_LAYER_NAME_FIELD = 'nombrec';
module.exports.WATERSHED_LAYER_ID = 'geoid';

module.exports.SEARCH_MIN_STRING_LENGTH = 3;

module.exports.MAIN_MAP_ZOOM = 4;
module.exports.MAIN_MAP_CENTER = [-102.3486328125, 23.60426184707018];
module.exports.HOME_BBOX = [-117.12776, 14.5388286402, -86.811982388, 32.72083];

module.exports.MONTHS = [
  'Ene',
  'Feb',
  'Mar',
  'Abr',
  'May',
  'Jun',
  'Jul',
  'Ago',
  'Sep',
  'Oct',
  'Nov',
  'Dic',
];

module.exports.CHART_COLORS = {
  // canvccrausv
  Acuícola: '#cd79cb',
  Agropecuario: '#cbaf75',
  Agua: '#160af7',
  'Asentamientos humanos': '#60c1cd',
  Bosque: '#61e6d0',
  'Dunas costeras': '#1763ef',
  Galería: '#4be318',
  Manglar: '#9fe456',
  Matorral: '#89e48a',
  Mezquital: '#836dde',
  Palmar: '#6b12d0',
  Pastizal: '#bccf6f',
  'País extranjero': '#3796d1',
  Pradera: '#c381db',
  Selva: '#dfd652',
  'Suelo desnudo': '#d68756',
  Sábana: '#2b37d9',
  'Vegetación acuática': '#d76879',
  'Vegetación desertica': '#e6468c',
  'Vegetación gipsófila': '#ed3c25',
  'Vegetación secundaria': '#2de163',

  // inecc_canvcc_ra_cont_nac_pob
  Rural: '#1f77b4',
  Urbano: '#ff7f0e',

  // inecc_canvcc_ra_nucleos_agrarios
  COMUNIDAD: '#2ca02c',
  EJIDO: '#ff7f0e',

  // incendios20152018
  2015: '#51ca55',
  2016: '#1c74d7',
  2017: '#e58815',
};

module.exports.CHART_LABELS = {
  inecc_canvcc_ra_cont_nac_pob: 'personas',
  canvccrausv: 'km²',
  inecc_canvcc_ra_nucleos_agrarios: 'km²',
  inecc_canvcc_ra_carreteras: 'm',
  incendios20152018: 'cantidad',
};
